import "./Typo.css";

export default function Typo({
  variant = "body1",
  children,
  className,
  ...props
}) {
  const variantsMap = {
    h1: "h1",
    h2: "h2",
    body1: "p",
    body2: "p",
    body3: "p",
    body4: "p",
    body5: "p",
  };

  const TypoTag = variantsMap[variant] || variantsMap["body1"];

  return (
    <TypoTag
      {...props}
      className={["Typo", `Typo-${variant}`, className]
        .filter(Boolean)
        .join(" ")}
    >
      {children}
    </TypoTag>
  );
}

export function Em({ children }) {
  return <span className="Em">{children}</span>;
}
